"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMainFrameNavigator = exports.MainFrameNavigator = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class MainFrameNavigator extends HTMLElement {
    constructor() {
        super();
        this.router = (0, lib_es2015_1.useRouter)();
        this.toggleMenu = () => {
            console.debug('toggleMenu()');
            this.menuToggleInput.checked = !this.menuToggleInput.checked;
        };
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
      <style>
      :host {
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.75);
        backdrop-filter: blur(3px);
        font-family: 'quaaykop-medium', sans-serif;
        
        transition: left 0.5s ease, display 0.5s allow-discrete;
        z-index: var(--highest-z-index);
      }
      
      :host:has(input.menu-toggle:checked) {
        left: 0;
      }
      
      div.menu-container {
          width: 15rem;
          height: 100%;
          display: flex;
          background-color: #000000;
          color: white;
          flex-direction: column;
          align-items: flex-end;
          gap: 0.5rem;
      }
      
      div.menu-container div.menu-button-container {
          width: 100%;
          padding: var(--main-frame-header-padding-top) var(--main-frame-header-padding-left);
          height: var(--main-frame-header-height);
          display: flex;
          justify-content: left;
          align-items: center;
          box-sizing: border-box;
      }
      
      div.menu-container div.menu-item {
          box-sizing: border-box;
          padding: 1rem 1rem 0 0;
          font-size: 1.5rem;
      }
      </style>
      <input class="menu-toggle" type="checkbox" hidden />
      <div class="menu-container">
        <div class="menu-button-container">
          <menu-button class="menu-btn" color="#ffffff"></menu-button>
        </div>
        <div class="menu-item homepage">AILEENE</div>
        <div class="menu-item">Philosophy</div>
        <div class="menu-item verify-product">Verify Product</div>
      </div>`;
        this.menuToggleInput = (0, lib_es2015_2.getQuerySelectOrThrowError)(shadow, 'input.menu-toggle');
        this.addEventListener('click', () => {
            this.toggleMenu();
        });
        this.homepageMenu = (0, lib_es2015_2.getQuerySelectOrThrowError)(shadow, 'div.menu-item.homepage');
        this.homepageMenu.addEventListener('click', () => {
            this.router.push(`/web`);
        });
        this.verifyProductMenu = (0, lib_es2015_2.getQuerySelectOrThrowError)(shadow, 'div.verify-product');
        this.verifyProductMenu.addEventListener('click', () => {
            this.router.push(`/web/authentication-qr-scanner`);
        });
    }
}
exports.MainFrameNavigator = MainFrameNavigator;
const defineMainFrameNavigator = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, MainFrameNavigator);
};
exports.defineMainFrameNavigator = defineMainFrameNavigator;
